import fetchApi, { isFetchError } from "@lib/api-fetcher/fetchApi";
import { API_ROUTES } from "@utils/constants";
import { reportError } from "@utils/errorReporting";

import { TErrorMessages, TRegistrationRequestBody } from "../types";
import mapLoginErrorsToMessages from "../utils/mapLoginErrorsToMessages";

const registerUser = async (
  userData: TRegistrationRequestBody
): Promise<{ isSuccess: boolean } & Partial<TErrorMessages>> => {
  try {
    await fetchApi({
      url: API_ROUTES.REGISTER,
      method: "POST",
      data: userData,
    });
    return { isSuccess: true };
  } catch (err) {
    if (isFetchError(err) && err.response?.status === 422) {
      const { errorMessage, fieldErrors } = mapLoginErrorsToMessages(err);
      return { isSuccess: false, errorMessage, fieldErrors };
    }
    reportError(err, { module: "registration" });
    return { isSuccess: false };
  }
};
export default registerUser;
